import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GreenPowerComponent } from './green-power.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MeterGroupModule } from 'primeng/metergroup';

@NgModule({
    declarations: [GreenPowerComponent],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        ChartModule,
        DropdownModule,
        ButtonModule,
        InputSwitchModule,
        MeterGroupModule,
    ],
    exports: [
        GreenPowerComponent
    ]
})
export class GreenPowerModule { }
